module.exports = __webpack_public_path__ + "static/media/bulb-grad.c74829b9.png";